module.exports = __webpack_public_path__ + "static/media/logout_icon.a5aa8359.png";